import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.scss'
import App from './App.tsx'
const doc=document.getElementById('root');
if(doc!==null) {
  createRoot(doc).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
